import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useCallingEnabled } from '@/hooks/useCalling'

/** Route guard: calling pages exist only while calling is available; otherwise back to the dashboard. */
export function RequireCalling({ children }: { children: ReactNode }) {
  const { enabled, isLoading } = useCallingEnabled()
  if (isLoading) return null
  return enabled ? <>{children}</> : <Navigate to="/dashboard" replace />
}
